import SessionService from "@/libraries/sessionjs/src";

const htmlBuilder = 'html';
const tipTapBuilder = 'tip-tap';
const storageKey = 'template_builder'

export default {
  data() {
    return {
      isAdvancedBuilder: false
    }
  },
  mounted() {
    this.isAdvancedBuilder = this.isHtmlBuilder();
  },
  methods: {
    isHtmlBuilder() {
      return this.getBuilder() === htmlBuilder;
    },
    isTipTapBuilder() {
      return this.getBuilder() === tipTapBuilder;
    },
    getBuilder() {
      return SessionService.get(storageKey) || tipTapBuilder;
    },
    chooseBuilder(builder) {
      SessionService.set(storageKey, builder, {
        path: "/",
        expires: new Date(this.$moment().add(1, 'years').format('YYYY-MM-DD'))
      });
    }
  },
  watch: {
    isAdvancedBuilder(value) {
      if (value) {
        this.chooseBuilder(htmlBuilder);
      } else {
        this.chooseBuilder(tipTapBuilder);
      }
    }
  }
}
